import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=35afb76c&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=35afb76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afb76c",
  null
  
)

export default component.exports